import { getElement } from '../Utility/Dom'

class Alert {
  private readonly closeButton: HTMLElement | null = null
  private readonly message: HTMLElement | null = null
  private readonly storageKey: string = 'alert-dismissed'

  constructor() {
    this.message = getElement('alert')
    this.closeButton = getElement('alert-close-button')
  }

  public init(): void {
    if (this.message === null) return
    if (this.closeButton === null) return

    if (this.isDismissed()) {
      this.hideMessage()
      return
    }

    this.addEvents()
  }

  private addEvents(): void {
    this.closeButton.addEventListener('click', (): void => {
      this.hideMessage()
      this.setDismissed()
    })
  }

  private hideMessage(): void {
    this.message.setAttribute('hidden', '')
  }

  private isDismissed(): boolean {
    try {
      return sessionStorage.getItem(this.storageKey) === 'true'
    } catch {
      return false
    }
  }

  private setDismissed(): void {
    try {
      sessionStorage.setItem(this.storageKey, 'true')
    } catch {
      // nothing to do
    }
  }
}

const alert = new Alert()
alert.init()
